import Search from "./Search/Search";
import Bookmarks from "./Bookmarks/Bookmarks";

export default Search;
export { Bookmarks };
